import type { ChangeEventHandler, MutableRefObject } from "react";
import Button from "@mui/material/Button";
import { CircularProgress, IconButton, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import type { File } from "@rmh/defs";

interface UploaderProps {
  uploaderRef: MutableRefObject<HTMLInputElement | null>;
  onChange: ChangeEventHandler;
  disabled?: boolean;
  label?: string;
  accept?: string;
  isLoading?: boolean;
}

interface FileListProps {
  fileList: File[];
  onFileDelete: (file: File, index: number) => void;
}

export const Uploader = ({
  onChange,
  disabled = false,
  uploaderRef,
  label = "Upload",
  accept = "image/jpeg, image/png, image/gif, application/pdf, text/plain",
  isLoading = false,
}: UploaderProps) => {
  return (
    <Button
      component="label"
      disabled={disabled}
      endIcon={
        isLoading ? <CircularProgress color="primary" size={20} /> : null
      }
      role={undefined}
      variant="outlined"
    >
      {label}

      <input
        accept={accept}
        className="hidden"
        disabled={disabled}
        onChange={onChange}
        ref={uploaderRef}
        type="file"
      />
    </Button>
  );
};

export const FileList = ({ fileList, onFileDelete }: FileListProps) => {
  return (
    <div className="border-rmh-gray-300 relative flex h-20 max-h-20 w-full gap-1 overflow-auto rounded-lg border px-4 py-2">
      <div className=" flex w-full flex-col gap-2">
        {fileList.map((file, index) => {
          return (
            <div
              className="inline-flex items-center justify-start gap-2 overflow-hidden"
              key={file.fileName}
            >
              <Typography className="body-m-strong flex items-center gap-2">
                {file.fileName}
              </Typography>
              <IconButton
                className="p-0"
                data-cy="delete-file-button"
                disableRipple
                onClick={() => {
                  onFileDelete(file, index);
                }}
              >
                <ClearIcon className="fill-rmh-red-600 text-2xl" />
              </IconButton>
            </div>
          );
        })}
      </div>
    </div>
  );
};
